import { runOnFeatureInit } from '@frontend/vanilla/core';

import { GoogleAnalyticsBootstrapService } from './google-analytics-bootstrap.service';

export function provide() {
    return [runOnFeatureInit(GoogleAnalyticsBootstrapService)];
}
